import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  field_publication_image: string;
  title: string;
  field_publication_title_ms: string;
  field_publication_title_zh: string;
  field_publication_desc_en: string;
  field_publication_desc_ms: string;
  field_publication_desc_zh: string;
  field_publication_redirect_url: string;
  field_publication_redirect_ms: string;
  field_publication_redirect_zh: string;
  sequence: number;
  status: string;
  created_at: string;
  updated_at: string;
}

// edit api call
const fetchPublicationDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await corporateCMSApi.get(`/api/get-publication-cards/${id}`);
  return response.data[0];
};

const usePublicationDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["awardsDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchPublicationDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { usePublicationDocumentDetails };
